import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  subtitle: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#00003D",
    opacity: 1,
    whiteSpace: "nowrap",
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
  data: {
    fontSize: "0.875rem",
    color: "#00003D",
    opacity: 1,
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },
}))

export default styles
